/**
 * Shared phone number formatting utility.
 * Formats input as (xxx) xxx-xxxx, stripping non-digit characters.
 */

/** Strip everything except digits */
export const stripNonDigits = (value: string): string => value.replace(/\D/g, '');

/**
 * Format a raw digit string into (xxx) xxx-xxxx.
 * Handles partial input gracefully for live typing.
 */
export const formatPhoneNumber = (value: string): string => {
    const digits = stripNonDigits(value).slice(0, 10);

    if (digits.length === 0) return '';
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/**
 * onChange handler helper — takes the raw input value, formats it,
 * and calls the setter with the formatted string.
 */
export const handlePhoneChange = (
    rawValue: string,
    setter: (formatted: string) => void,
): void => {
    setter(formatPhoneNumber(rawValue));
};
